<div class="flex w-full flex-col gap-1">
  @if (label()) {
    <span class="font-bold">{{ label() }}</span>
  }
  <button
    id="dropdown-container"
    class="hover:bg-theme-gray-400 relative h-full w-full rounded-[4px] border px-2 py-1"
    [ngClass]="{
      'border-theme-secondary-gray': !isInvalid(),
      'border-error': isInvalid(),
      'bg-theme-gray-400 cursor-not-allowed opacity-60': isDisabled(),
      'bg-theme-gray-400 ring-error ring-1': isOpened() && isInvalid(),
      'bg-theme-gray-400 ring-theme-secondary-gray ring-1': isOpened() && !isInvalid(),
    }"
    (click)="toggleMenu()"
    #menuButton>
    <div class="flex w-full justify-between gap-2" [ngClass]="isDisabled() ? 'opacity-60' : ''">
      <div class="flex w-full justify-start overflow-hidden" style="flex-shrink: 1">
        <span class="flex items-center truncate">
          {{ selectedOption()?.label ?? placeholder() }}
        </span>
      </div>
      <span class="material-icons flex-shrink-0">
        @if (isOpened()) {
          expand_less
        } @else {
          expand_more
        }
      </span>
    </div>
    @if (isOpened()) {
      <div
        class="absolute top-full right-0 left-0 z-1000 flex flex-col rounded bg-white shadow-[0px_2px_4px_rgba(0,0,0,0.33)]">
        @if (enableSearch()) {
          <shared-ui-text
            class="p-2"
            placeholder="Suche..."
            (click)="$event.stopPropagation()"
            [formControl]="searchStringFormControl"
            name="search">
            <span class="material-icons">search</span>
          </shared-ui-text>
        }
        @if (enableAddButton()) {
          <div class="flex flex-col gap-y-2 p-2">
            <shared-ui-text
              [placeholder]="addInputPlaceholder()"
              (click)="$event.stopPropagation()"
              [formControl]="customValueFormControl"
              name="addElement">
              <span class="material-icons">add</span>
            </shared-ui-text>
            <button sharedCoreButton variant="primary" (click)="addOption()">Hinzufügen</button>
          </div>
        }
        @for (option of filteredOptions; track $index) {
          <button
            class="flex rounded px-2 py-1 transition hover:bg-[#E9F4F8] hover:font-medium hover:text-[#3D85A2] focus:bg-[#E9F4F8] focus:font-medium focus:text-[#3D85A2]"
            (click)="onValueSelected(option)"
            #optionButton>
            <div class="flex w-full justify-start">
              <span class="truncate">{{ option.label }}</span>
            </div>
          </button>
        }
        @if (filteredOptions.length !== dropdownOptions().length) {
          <span class="pb-2 text-sm text-gray-500"
            >{{ dropdownOptions().length - filteredOptions.length }} Elemente ausgeblendet</span
          >
        }
      </div>
    }
  </button>
  @if (isInvalid()) {
    <span class="text-error">{{ warningText() }}</span>
  }
</div>
